<div class="bg-m1 flex h-full cursor-default flex-col">
  <div
    class="flex h-2 flex-1 flex-row items-center justify-center overflow-y-auto"
  >
    <div class="flex w-96 flex-col items-center">
      <div class="text-s2 flex max-w-sm text-center text-2xl font-semibold">{{
        pageTitle
      }}</div>

      <div class="text-s2 mt-5 flex text-center text-xl">{{ email }}</div>
      <form
        class="flex w-96 flex-col"
        [formGroup]="setPasswordForm"
        (ngSubmit)="setPassword()"
      >
        <input
          spellcheck="false"
          data-cy="completeRegistrationPasswordInput"
          class="form-input border-s3 focus:border-m600 mt-9 rounded"
          [ngClass]="{
            'border-r600':
              setPasswordForm.controls['newPassword'].invalid &&
              setPasswordForm.controls['newPassword'].touched
          }"
          type="password"
          formControlName="newPassword"
          placeholder="Password"
        />
        <m-validation
          [control]="setPasswordForm.controls['newPassword']"
        ></m-validation>

        <button
          data-cy="completeRegistrationSignUpButton"
          class="bg-m600 text-m0 mt-1 rounded py-3 text-base font-medium focus:outline-none"
          type="submit"
          >SignUp</button
        >
      </form>
    </div>
  </div>
</div>
